// test1844
(1844 && 0);
